import format from 'date-fns/format';
import { casesToDecode } from './casesToDecodeChannels.js';
import { config, msg } from 'api';
import errorHandler from 'utils/errorHandler';
import orderStatuses from 'apps/orders/orderStatuses';

export const DELETE_CUSTOMER_MESSAGE = 'DELETE_CUSTOMER_MESSAGE';
export const REQUEST_CUSTOMER_MESSAGES = 'REQUEST_CUSTOMER_MESSAGES';
export const RECEIVE_CUSTOMER_MESSAGES = 'RECEIVE_CUSTOMER_MESSAGES';
export const RECEIVE_CUSTOMER_MESSAGES_ERROR = 'RECEIVE_CUSTOMER_MESSAGES_ERROR';

const editableOrderStatuses = [orderStatuses.EDITABLE, orderStatuses.EDIT_MODE];

function requestCustomerMessages() {
  return {
    type: REQUEST_CUSTOMER_MESSAGES,
  };
}

function receiveCustomerMessages(messages = []) {
  const messagesWithDecodedChannels = messages
    .map(message => ({
      ...message,
      channels: decodeChannels(message.channels),
    }));

  return {
    type: RECEIVE_CUSTOMER_MESSAGES,
    messages: messagesWithDecodedChannels,
  };
}

function decodeChannels(channels) {
  const decodedChannelsArray = (Array.isArray(channels) ? channels : [channels])
    .map(channel => decodeChannel(channel));
  const decodedChannelsFlattenedArray = [].concat(...decodedChannelsArray);
  return decodedChannelsFlattenedArray;
}

function decodeChannel(channel) {
  return casesToDecode(shouldDisplayDesktopAsPopupLIHPMessages)[channel] ||
    { channels: 'ERROR_DECODING_CHANNEL', location: 'ERROR_DECODING_CHANNEL' };
}

function receiveCustomerMessagesError() {
  return {
    type: RECEIVE_CUSTOMER_MESSAGES_ERROR,
  };
}

let shouldDisplayDesktopAsPopupLIHPMessages = false;

export function ensureCustomerMessages() {
  return (dispatch, getState, { network }) => {
    const {
      customerMessages,
      user: {
        customerNum,
        betaFeatures: userBetaFeatures = [],
      },
      betaFeatures = [],
    } = getState();

    shouldDisplayDesktopAsPopupLIHPMessages = [...betaFeatures, ...userBetaFeatures]
      .includes('DESKTOP_AS_POPUP_LIHP_MESSAGES');

    if (customerMessages.isFetching || !customerNum) {
      return Promise.resolve(); // fetching is in progress or user is not authenticated
    }
    dispatch(requestCustomerMessages());
    return network.get(`${config.apiBasePath}/customer-messages`)
      .then(content => dispatch(receiveCustomerMessages(content)))
      .catch(err => {
        dispatch(receiveCustomerMessagesError());
        errorHandler(err);
      });
  };
}

export function amendChangeDeliveryToCustomerMessages(data) {
  const slotHeldUntilDate = format(data.expirationTime, config.dateAndTimeExtendedFormat);
  const { changeDelivery } = msg.mobileNotifications;
  const message = {
    id: changeDelivery.id,
    type: changeDelivery.type,
    title: changeDelivery.title,
    body: changeDelivery.body(slotHeldUntilDate),
    deletable: false,
    channels: ['MOBILE_LOGGED_IN_HOMEPAGE'],
  };

  return receiveCustomerMessages([message]);
}

export function amendEditOrderToCustomerMessages({ cutoffTime, status }) {
  const editOrderUntilDate = format(cutoffTime, config.dateAndTimeExtendedFormat, null);
  const { editOrderDelivery } = msg.mobileNotifications;

  if (!editableOrderStatuses.includes(status) ||
    editOrderUntilDate === null ||
    editOrderUntilDate === 'Invalid Date') return { type: '' };

  const message = {
    id: editOrderDelivery.id,
    type: editOrderDelivery.type,
    title: editOrderDelivery.title,
    body: editOrderDelivery.body(editOrderUntilDate),
    deletable: false,
    channels: ['MOBILE_LOGGED_IN_HOMEPAGE'],
  };

  return receiveCustomerMessages([message]);
}

export function amendEditOrderToCustomerMessages_DETAILS(data) {
  const { deliverySlot: { cutoffTime }, status } = data && data.data;

  return amendEditOrderToCustomerMessages({ cutoffTime, status });
}

export function amendEditOrderToCustomerMessages_SUMMARY(data) {
  const { nextOrder: { deliverySlot: { cutoffTime }, status } } = data && data.data;

  return amendEditOrderToCustomerMessages({ cutoffTime, status });
}

export function deleteCustomerMessage(message) {
  return {
    type: DELETE_CUSTOMER_MESSAGE,
    message,
  };
}

export function deleteEditOrderFromCustomerMessages() {
  const { editOrderDelivery } = msg.mobileNotifications;
  return deleteCustomerMessage({ id: editOrderDelivery.id });
}
